/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PNS, PNSInterface } from "../PNS";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "forwarder",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "flags",
        type: "uint256",
      },
    ],
    name: "ConfigUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "manager",
        type: "address",
      },
      {
        indexed: true,
        internalType: "bool",
        name: "role",
        type: "bool",
      },
    ],
    name: "ManagerChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256[]",
        name: "data",
        type: "uint256[]",
      },
    ],
    name: "MetadataUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "string",
        name: "keyIndex",
        type: "string",
      },
      {
        indexed: false,
        internalType: "string",
        name: "key",
        type: "string",
      },
    ],
    name: "NewKey",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "resolver",
        type: "address",
      },
    ],
    name: "NewResolver",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "subtokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "string",
        name: "name",
        type: "string",
      },
    ],
    name: "NewSubdomain",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ResetRecords",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "oldRoot",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newRoot",
        type: "address",
      },
    ],
    name: "RootOwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "keyHash",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "string",
        name: "value",
        type: "string",
      },
    ],
    name: "Set",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "keyHash",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "SetLink",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "addr",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "SetName",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "nftAddr",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "nftTokenId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "SetNftName",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [],
    name: "FLAGS",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "GRACE_PERIOD",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "_root",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string[]",
        name: "keys",
        type: "string[]",
      },
    ],
    name: "addKeys",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "available",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "bound",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "bounded",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "exists",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "expire",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "key",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "get",
    outputs: [
      {
        internalType: "string",
        name: "value",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "keyHash",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getByHash",
    outputs: [
      {
        internalType: "string",
        name: "value",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "keyHash",
        type: "uint256",
      },
    ],
    name: "getKey",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string[]",
        name: "keys",
        type: "string[]",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getMany",
    outputs: [
      {
        internalType: "string[]",
        name: "values",
        type: "string[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "keyHashes",
        type: "uint256[]",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getManyByHash",
    outputs: [
      {
        internalType: "string[]",
        name: "values",
        type: "string[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
    ],
    name: "getName",
    outputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
    ],
    name: "getNameUnchecked",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "nftAddr",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "nftTokenId",
        type: "uint256",
      },
    ],
    name: "getNftName",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "source",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "target",
        type: "uint256",
      },
    ],
    name: "getlink",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "source",
        type: "uint256",
      },
      {
        internalType: "uint256[]",
        name: "targets",
        type: "uint256[]",
      },
    ],
    name: "getlinks",
    outputs: [
      {
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "isApprovedOrOwner",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
    ],
    name: "isManager",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "forwarder",
        type: "address",
      },
    ],
    name: "isTrustedForwarder",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "newTokenId",
        type: "uint256",
      },
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
    ],
    name: "mintSubdomain",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "nameExpired",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "origin",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "parent",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint64",
        name: "duration",
        type: "uint64",
      },
      {
        internalType: "uint256",
        name: "baseNode",
        type: "uint256",
      },
    ],
    name: "register",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint64",
        name: "duration",
        type: "uint64",
      },
    ],
    name: "renew",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "root",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "keyHash",
        type: "uint256",
      },
      {
        internalType: "string",
        name: "value",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "setByHash",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_writable",
        type: "uint256",
      },
    ],
    name: "setContractConfig",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "manager",
        type: "address",
      },
      {
        internalType: "bool",
        name: "role",
        type: "bool",
      },
    ],
    name: "setManager",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "keyHashes",
        type: "uint256[]",
      },
      {
        internalType: "string[]",
        name: "values",
        type: "string[]",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "setManyByHash",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "tokenIds",
        type: "uint256[]",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "origin",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "parent",
            type: "uint256",
          },
          {
            internalType: "uint64",
            name: "expire",
            type: "uint64",
          },
        ],
        internalType: "struct PNS.Record[]",
        name: "data",
        type: "tuple[]",
      },
    ],
    name: "setMetadataBatch",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "setName",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "nftAddr",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "nftTokenId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "setNftName",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "source",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "target",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "setlink",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "source",
        type: "uint256",
      },
      {
        internalType: "uint256[]",
        name: "targets",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
    ],
    name: "setlinks",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferRootOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class PNS__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    forwarder: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<PNS> {
    return super.deploy(forwarder, overrides || {}) as Promise<PNS>;
  }
  getDeployTransaction(
    forwarder: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(forwarder, overrides || {});
  }
  attach(address: string): PNS {
    return super.attach(address) as PNS;
  }
  connect(signer: Signer): PNS__factory {
    return super.connect(signer) as PNS__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): PNSInterface {
    return new utils.Interface(_abi) as PNSInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): PNS {
    return new Contract(address, _abi, signerOrProvider) as PNS;
  }
}
